import signService from "@/services/sign/services/sign.service";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { SignCreateModule } from "@/store/modules/sign-create.store";
import { ConflictException } from "../../exceptions/http";
import { FetchStrategy, SharedContentDocument, safeFetch } from "../SharedContentFetchStrategy";

export class SignFetchStrategy implements FetchStrategy {
  canHandle(refType: string): boolean {
    return refType === ResourceEnum.SIGN;
  }

  async fetch(partnerId: string, refId: string): Promise<SharedContentDocument> {
    try {
      const result = await signService.find(partnerId, refId);

      return {
        refId,
        refType: ResourceEnum.SIGN,
        refDocument: result
      };
    } catch (e) {
      // Check if this is a conflict exception, which might mean the document might already be signed
      if (e instanceof ConflictException) {
        const result = await safeFetch(refId, ResourceEnum.SIGNED, async () => {
          return await SignCreateModule.findSigned({ partnerId, requestId: refId });
        });

        return result;
      }

      // Return error result if all else fails
      else
        return {
          refId,
          refType: ResourceEnum.SIGN,
          refDocument: null,
          error: e instanceof Error ? e : new Error(String(e))
        };
    }
  }
}
